module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-pv.jpg?v=f4cda376";